import compose from 'lodash.flowright';
import { mapProps } from 'recompose';

import DigitalBundlesMissingConfiguration from './DigitalBundlesMissingConfiguration';
import withModal from '../../../../../../../../../components/global/modal/withModal';

export const DIGITAL_BUNDLES_MISSING_CONFIGURATION_MODAL =
  'MODAL/DIGITAL_BUNDLES_MISSING_CONFIGURATION';

export default withModal(
  compose(
    mapProps(({ onRequestClose, actionProps = {}, ...props }) => ({
      onClose: onRequestClose,
      ...actionProps,
      ...props,
    })),
  )(DigitalBundlesMissingConfiguration),
  {
    name: DIGITAL_BUNDLES_MISSING_CONFIGURATION_MODAL,
    size: 'sm',
    type: 'full',
  },
);
